import { render, staticRenderFns } from "./TesteCegSisgd.vue?vue&type=template&id=51c0c1bc&scoped=true&"
import script from "./TesteCegSisgd.vue?vue&type=script&lang=js&"
export * from "./TesteCegSisgd.vue?vue&type=script&lang=js&"
import style0 from "./TesteCegSisgd.vue?vue&type=style&index=0&id=51c0c1bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c0c1bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VIcon,VProgressCircular,VSimpleTable})
